<template>
	<div>
		<Fieldset :legend="$t('searchHeader')" :toggleable="true">
			<div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
				<div class="p-formgrid p-grid p-col-12 p-mt-2">
					<div class="p-field p-col">
						<label for="event_name">{{$t('event_name')}}</label>
						<InputText id="event_name" type="text" v-model="event_name"/>
					</div>
					<div class="p-field p-col">
						<label for="startDate">{{$t('startDate')}}</label>
						<Calendar dateFormat="dd/mm/yy" :showButtonBar="true" :maxDate="maxDate" :monthNavigator="true" :yearNavigator="true" yearRange="2000:2050" :locale="th" id="disaster_startDate" v-model="startDate"></Calendar>
					</div>
					<div class="p-field p-col">
						<label for="toDate">{{$t('toDate')}}</label>
						<Calendar dateFormat="dd/mm/yy" :showButtonBar="true" :minDate="minDate" :monthNavigator="true" :yearNavigator="true" yearRange="2000:2050" :locale="th" id="disaster_toDate" v-model="toDate"></Calendar>
					</div>
				</div>
				<div class="p-formgrid p-grid p-col-12 p-mt-2">
					<div class="p-field p-col">
						<label for="disasterType">{{$t('disaster_type')}}</label>
						<Dropdown v-model="disasterTypeSelect" :options="disasterTypeOptions" optionLabel="system_name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
							<template #value="disasterTypeOptions">
								<div v-if="disasterTypeOptions.value">
									<div>{{disasterTypeOptions.value.system_name}}</div>
								</div>
								<span v-else>
									{{disasterTypeOptions.placeholder}}
								</span>
							</template>
							<template #option="disasterTypeOptions">
								<div>{{disasterTypeOptions.option.system_name}}</div>
							</template>
						</Dropdown>
					</div>
					<div class="p-field p-col">
						<label for="disasterDetailOptions">{{$t('disaster_detail')}}</label>
						<Dropdown v-model="disasterDetailSelect" :options="disasterDetailOptions" optionLabel="system_name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
							<template #value="disasterDetailOptions">
								<div v-if="disasterDetailOptions.value">
									<div>{{disasterDetailOptions.value.system_name}}</div>
								</div>
								<span v-else>
									{{disasterDetailOptions.placeholder}}
								</span>
							</template>
							<template #option="disasterDetailOptions">
								<div>{{disasterDetailOptions.option.system_name}}</div>
							</template>
						</Dropdown>
					</div>
					<div class="p-field p-col">
						<label for="disasterStatusOptions">{{$t('disaster_status')}}</label>
						<Dropdown v-model="disasterStatusSelect" :options="disasterStatusOptions" optionLabel="name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
							<template #value="disasterStatusOptions">
								<div v-if="disasterStatusOptions.value">
									<div>{{disasterStatusOptions.value.name}}</div>
								</div>
								<span v-else>
									{{disasterStatusOptions.placeholder}}
								</span>
							</template>
							<template #option="disasterStatusOptions">
								<div>{{disasterStatusOptions.option.name}}</div>
							</template>
						</Dropdown>
					</div>
				</div>
				
				<div class="p-formgrid p-grid p-col-12 p-mt-2">
					<div class="p-field p-col">
						<label for="provinceOptions">{{$t('province')}}</label>
						<Dropdown v-model="selectedProvince" :options="provinceOptions" optionLabel="province_name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
							<template #value="provinceOptions">
								<div v-if="provinceOptions.value">
									<div>{{provinceOptions.value.province_name}}</div>
								</div>
							</template>
							<template #option="provinceOptions">
								<div>{{provinceOptions.option.province_name}}</div>
							</template>
						</Dropdown>
					</div>
					
					<div class="p-field p-col">
						<label for="amphurOptions">{{$t('amphur')}}</label>
						<Dropdown :disabled="isDisabledAmphur == 1" v-model="selectedAmphur" :options="amphurOptions" optionLabel="amphur_name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
							<template #value="amphurOptions">
								<div v-if="amphurOptions.value">
									<div>{{amphurOptions.value.amphur_name}}</div>
								</div>
							</template>
							<template #option="amphurOptions">
								<div>{{amphurOptions.option.amphur_name}}</div>
							</template>
						</Dropdown>
					</div>

					<div class="p-field p-col">
						<label for="tambonOptions">{{$t('tambon')}}</label>
						<Dropdown :disabled="isDisabledTambon == 1" v-model="selectedTambon" :options="tambonOptions" optionLabel="tambon_name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
							<template #value="tambonOptions">
								<div v-if="tambonOptions.value">
									<div>{{tambonOptions.value.tambon_name}}</div>
								</div>
							</template>
							<template #option="tambonOptions">
								<div>{{tambonOptions.option.tambon_name}}</div>
							</template>
						</Dropdown>
					</div>
				</div>

				<div class="p-formgrid p-grid p-col-12">
					<div class="p-field p-col-4">
						<label for="disaster_location">{{$t('disaster_location')}}</label>
						<InputText id="disaster_location" type="text" v-model="disaster_location"/>
					</div>
					<div class="p-field p-col-4">
						<label for="organize">{{$t('main_organize')}}</label>
						<InputText id="organize" type="text" v-model="selectedOrganize.name" disabled/>
					</div>
					<div class="p-field p-col-2 p-mt-2">
						<div>
							<Button @click="showOrganize=true" icon="pi pi-ellipsis-h" class="p-button-secondary p-mt-5 p-mr-2" />
							<Button @click="selectedOrganize={}" icon="pi pi-times" class="p-button-danger p-mt-5" />	
						</div>
					</div>
					<div class="p-field p-col p-mt-2">
						<div class="p-formgrid p-grid p-jc-end p-mt-5">
							<Button @click="clearSearchField()" :label="$t('clearBtn')" class="p-button-clear p-ml-3 p-mr-3" />
							<Button @click="searchDisasterInfo()" :label="$t('searchBtn')" class="p-button-info " />
						</div>
					</div>
				</div>
			</div>
		</Fieldset>
		
		<Dialog  :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{width: '80%'}" :contentStyle="{'overflow-y': 'scroll'}">
			<organize-table @selectOrganization="selectedOrganize_passValue"></organize-table>
		</Dialog>

		<div class="card p-fluid p-mt-2">
			<DataTable :value="disasterInfo_table" :paginator="true" :rows="10" :loading="loading"
				dataKey="id" :rowHover="true" :filters="filters"
				paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				:rowsPerPageOptions="[10,20,50]"
				currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}">
				<template #header>
					<div class="table-header p-col-3" style="margin-left:auto">
						<span class="p-input-icon-left">
							<i class="pi pi-search"/><InputText v-model="filters['global']" :placeholder="$t('searchHeader')"/>
						</span>
					</div>
				</template>
				<template #empty>{{$t('TableEmpty')}}</template>
				<Column field="event_name" :header="$t('event_name')" :sortable="true">
					<template #body="dataTable" >
						<div hidden>{{dataTable.data.hazard_id}}</div>
						{{dataTable.data.event_name}}
					</template>
				</Column>
				<Column field="event_date_alias" :header="$t('disaster_callDatetime')" :sortable="true">
					<template #body="dataTable" >
						{{dataTable.data.event_date_alias}}
					</template>
				</Column>
				<Column field="disaster_name" :header="$t('disaster_type')" :sortable="true">
					<template #body="dataTable" >
						{{dataTable.data.disaster_name}}
					</template>
				</Column>
				<Column field="detail_name" :header="$t('disaster_detail')" :sortable="true">
					<template #body="dataTable" >
						<div v-if="dataTable.data.detail_name != null">{{dataTable.data.detail_name}}</div>
						<div v-else>-</div>
					</template>
				</Column>
				<Column field="event_level" :header="$t('disaster_level')" :sortable="true">
					<template #body="dataTable" >
						{{dataTable.data.event_level}}
					</template>
				</Column>
				<Column field="event_status" :header="$t('disaster_status')" :sortable="true">
					<template #body="dataTable" >
						<div v-if="dataTable.data.event_status == 'onworking'">{{$t('onworking')}}</div>
						<div v-else>{{$t('finish')}}</div>
					</template>
				</Column>
				<Column field="location" :header="$t('disaster_location')" :sortable="true">
					<template #body="dataTable" >
						<div v-if="dataTable.data.location != ''">{{dataTable.data.location}}</div>
						{{dataTable.data.tambon_name}} {{dataTable.data.amphur_name}} {{dataTable.data.province_name}}
					</template>
				</Column>
				<Column field="event_operator_table" :header="$t('main_organize')" :sortable="true">
					<template #body="dataTable" >
						<div v-if="dataTable.data.event_operator_table == '[]'">-</div>
						<div v-else>
							<div v-for="operator in JSON.parse(dataTable.data.event_operator_table)" :key="operator.operating_id">
								<div v-if="operator.organize[0] == '1'">{{operator.operating_name}}</div>
								<div v-else>-</div>
							</div>
						</div>
					</template>
				</Column>	
			</DataTable>
		</div>
	</div>

</template>

<script>
import organizeTable from './OrganizeTable';
 
export default {
	components: {
		organizeTable,
    },
	data() {
		return{
			th : this.$thaidate,
			event_name : '',
			startDate : '',
			toDate : '',
			disasterTypeOptions : [],
			disasterTypeSelect : null,
			disasterDetailOptions : [],
			disasterDetailSelect : null,
			disasterStatusOptions : [{'id':'onworking','name':this.$i18n.t('onworking')},{'id':'finish','name':this.$i18n.t('finish')}],
			disasterStatusSelect : null,
			provinceOptions : [],
			selectedProvince : null,
			amphurOptions : [],
			selectedAmphur : null,
			isDisabledAmphur : 1,
			tambonOptions : [],
			selectedTambon : null,
			isDisabledTambon : 1,
			disaster_location : '',
			showOrganize : false,
			selectedOrganize : {},
			disasterInfo_table : [],
			filters: {},
			loading: false,
			minDate: null,
			maxDate: null
		}
	},
	watch:{
		async selectedProvince(val){
			this.selectedAmphur = null;
			if(val != null){
				this.isDisabledAmphur = 0;
				await this.axios.post(`${this.$url_service}/general/country`, { body: { topic: 'get-amphur', province_id: val.province_id }}).then(response => {(this.amphurOptions = response.data.data),(this.amphurOptions.splice(0,0,{'amphur_id':'getall','amphur_name':this.$i18n.t('selectAll')}))})
			}else{
				this.isDisabledAmphur = 1;
				this.selectedAmphur = null;
			}
		},

		async selectedAmphur(val){
			this.selectedTambon = null;
			if(val != null){
				this.isDisabledTambon = 0;
				await this.axios.post(`${this.$url_service}/general/country`, {body: { topic: 'get-tambon',amphur_id: val.amphur_id }}).then(response => {(this.tambonOptions = response.data.data),(this.tambonOptions.splice(0,0,{'tambon_id':'getall','tambon_name':this.$i18n.t('selectAll')}))})
			}else{
				this.isDisabledTambon = 1;
				this.selectedTambon = null;
			}
		},

		async disasterTypeSelect(val){
			if(val != null){
				this.disasterDetailSelect = null
				await this.axios.post(`${this.$url_service}/get/datagroup`, { body: { topic: 'get-detail-disaster' , id:val.system_id}}).then(response => {(this.disasterDetailOptions = response.data.data),(this.disasterDetailOptions.splice(0,0,{'system_id':'getall','system_name':this.$i18n.t('selectAll')}))})
			}else{
				this.disasterDetailOptions = []
				this.disasterDetailSelect = null
			}
		},

		disasterInfo_table(val){
			if(val.length > 0){
				this.loading = false
			}else{
				this.loading = false
			}
		},

		startDate(val){
			if(val != ''){
				this.minDate = val
				if(val == null){
					this.startDate = ''
				}
			}else{
				this.toDate = ''
				this.maxDate = null
			}
			
		},

		toDate(val){
			if(val != ''){
				this.maxDate = val
				if(val == null){
					this.toDate = ''
				}
			}
		}
	},
	async created() {
		this.loading = true
		await this.axios.post(`${this.$url_service}/disaster`, { body: { topic: 'get-table'}}).then(response => (this.disasterInfo_table = response.data.data))

		this.disasterStatusOptions = [{'id':'getall','name':this.$i18n.t('selectAll')},{'id':'onworking','name':this.$i18n.t('onworking')},{'id':'finish','name':this.$i18n.t('finish')}]
		await this.axios.post(`${this.$url_service}/initial/option`, { body: { group: 'dg-02'}}).then(response => {(this.disasterTypeOptions = response.data.data),(this.disasterTypeOptions.splice(0,0,{'system_id':'getall','system_name':this.$i18n.t('selectAll')}))})
		await this.axios.post(`${this.$url_service}/initial/option`, { body: { group: 'dg-15'}}).then(response => (this.dailyGroup1Options = response.data.data))
		await this.axios.post(`${this.$url_service}/general/country`, { body: { topic: 'get-province'}}).then(response => {(this.provinceOptions = response.data.data),(this.provinceOptions.splice(0,0,{'province_id':'getall','province_name':this.$i18n.t('selectAll')}))})
	},
	
	methods: {
		selectedOrganize_passValue(variable){
			this.showOrganize = false
			this.selectedOrganize = {'id':variable.organize_id,'name':variable.organize_name};
		},

		async searchDisasterInfo(){
			var start_date, to_date
			this.loading = true
			if(this.startDate != ''){
				const start = new Date(this.startDate)
				const ye_s = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(start)
				const mo_s = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(start)
				const da_s = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(start)
				start_date = `${ye_s}-${mo_s}-${da_s}`
			}else{ start_date = '' }

			if(this.toDate != ''){
				const to = new Date(this.toDate)
				const ye_t = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(to)
				const mo_t = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(to)
				const da_t = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(to)
				to_date = `${ye_t}-${mo_t}-${da_t}`
			}else{ to_date = '' }

			await this.axios.post(`${this.$url_service}/disaster`, {
				body: {
					topic: 'search-table',
					name: this.event_name,
					startdate: start_date,
					todate: to_date,
					disaster: this.disasterTypeSelect,
					detail: this.disasterDetailSelect,
					status: this.disasterStatusSelect,
					province: this.selectedProvince,
					amphur: this.selectedAmphur,
					tambon: this.selectedTambon,
					location: this.disaster_location,
					organize: this.selectedOrganize
				}
			}).then(response => (this.disasterInfo_table = response.data.data))
			this.loading = false
		},
		
		clearSearchField(){
			this.event_name = ''
			this.startDate = ''
			this.toDate = ''
			this.disasterTypeSelect = null
			this.disasterStatusSelect = null
			this.selectedProvince = null
			this.disaster_location = ''
			this.selectedOrganize = {}
			this.disasterInfo_table = []
		}
	}
}
</script>

<style scoped>
.p-field {
	margin-bottom: 0rem;
}
</style>

<style>

.p-datatable-thead{
	border: 2px solid #d6d6d6;
}

.p-datatable-tbody{
	border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
	.p-multiselect {
		min-width: 15rem;
	}

	.multiselect-custom {

		.p-multiselect-label:not(.p-placeholder) {
			padding-top: .25rem;
			padding-bottom: .25rem;
		}

		.item {
			display: flex;
			align-items: center;
		}

		.item-value {
			padding-left: 10px;
			padding-right: 10px;
			border-radius: 3px;
			display: inline-flex;
			margin-right: .5rem;
			background-color: var(--primary-color);
			color: var(--primary-color-text);
		}
	}
</style>
